export default "__VITE_ASSET__5f5338e9__"